import {
  actionsLockMessage,
  type ActionsLockReason,
} from '@/lib/proposals/utils/clarifyingGating';

/**
 * Accessible notice shown above the action cards while they're locked by an
 * unanswered (or in-flight) gating question. Its own live region — the
 * content wrapper it's rendered into is not one — so it's announced per
 * WCAG 4.1.3, matching the pattern in ClarifyingQuestionsPanel.
 */
export function ActionsLockedNotice({ reason }: { reason: ActionsLockReason }) {
  return (
    <div
      role='status'
      aria-atomic='true'
      data-instance='actions-locked-notice'
      className='mb-2 text-sm text-fg-secondary'
    >
      {actionsLockMessage(reason)}
    </div>
  );
}
